import { ApiMethod } from '@wajeez-web/stores/base';
import { paymentClient, Server } from '@wajeez-web/core/api-base';
import {
  thunkErrorHandler,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';

export const getVoiceActorsDatatable: ApiMethod<
  Server.VoiceActorDatatable,
  Server.TableOfVoiceActorColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_VoiceActor_Client(
          undefined,
          paymentClient
        );

        return client.voiceActor_datatable_post_V1(data);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const getVoiceActorsLookups: ApiMethod<
  string | undefined,
  Server.VoiceActorResponse[],
  void
> = async (searchString, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_VoiceActor_Client(
          undefined,
          paymentClient
        );

        const response = await client.voiceActor_lookup_get_V1(undefined, searchString);

        return response;
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const getVoiceActorById: ApiMethod<
  string,
  Server.VoiceActorResponse,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_VoiceActor_Client(
          undefined,
          paymentClient
        );

        return client.voiceActor_byId_get_V1(undefined, id);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const createVoiceActor: ApiMethod<
  Server.CreateVoiceActorCommand,
  number,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_VoiceActor_Client(
          undefined,
          paymentClient
        );

        return client.voiceActor_post_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const editVoiceActor: ApiMethod<
  Server.EditVoiceActorCommand,
  void,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Server.Server_VoiceActor_Client(
            undefined,
            paymentClient
          );

          return client.voiceActor_put_V1(body);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue
  );
};

export const getVoiceActorByIdMultilingual: ApiMethod<
  string,
  Server.VoiceActorMultilingualResponse,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_VoiceActor_Client(
        undefined,
        paymentClient
      );

      const response = await client.voiceActor_multilingualById_get_V1(id);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const setContentEntityVoiceActor: ApiMethod<
  Server.SetContentEntityVoiceActorCommand,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Server.Server_ContentEntities_Client(
            undefined,
            paymentClient
          );

          return client.contentEntities_setVoiceActor_post_V1(body);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue
  );
};
